export default {
  path: 'Invoicing',
  component: () => import(/* webpackChunkName: "category-list" */ '@/pages/audit/Invoicing'),
  meta: {title: '发票代开'},
  children: [{
    path: ':invoicing_id/view',
    component: () => import( /* webpackChunkName: "individual-view" */ '@/pages/audit/CreateEdit'),
    meta: {
      title: '个体户发票代开详情'
    },
  }]
}